export interface ControlProps<T> {
    readonly value: T | null;
    readonly validate: boolean;
    readonly label: string;
}

export interface ControlCallbacks<T> {
    getValue: () => T | null;
    validateCurrentValue?: () => boolean;
}

type ControlEmit = (event: 'input' | 'validated', ...args: any[]) => void;

export function Control<T>(
    props: ControlProps<T>,
    emit: ControlEmit,
    callbacks: ControlCallbacks<T>,
) {
    const validateCurrentValue = callbacks.validateCurrentValue ?? (() => true);

    function updateValue(): void {
        const value = callbacks.getValue();
        const isValid = validateCurrentValue();

        emit('input', isValid ? value : null);
        emit('validated', isValid);
    }

    function isInvalid(): boolean {
        return props.validate;
    }

    return {
        updateValue,
        isInvalid,
    };
}
